
export const common = {
  // Navigation
  home: "ホーム",
  features: "主な強み",
  cases: "実績紹介",
  pricing: "サービス料金",
  about: "私たちについて",
  getStarted: "始める",
  language: "日本語",

  // Common Actions
  contactUs: "お問い合わせ",
  viewFaq: "よくある質問を見る",

  // Hero Section
  heroSubtitle: "Flidge（フリッジ） - ゲームに特化した最高品質のローカライゼーションサービス",
  heroTitle1: "世界中のプレイヤーに",
  heroTitle2: "ゲームの真の魅力を伝える",
  heroDescription: "最先端のAI技術を活用し、正確で迅速、かつコストパフォーマンスに優れた多言語翻訳ソリューションを開発者に提供。世界中のプレイヤー市場開拓とビジネスチャンスの創出を全面的にサポートします",
  learnMore: "強みを見る",
  freeTrial: "無料体験",
  socialProof: "80社以上のゲーム開発会社・パブリッシャーが選ぶサービス",
  
  // Features Section
  featuresSubtitle: "主な強み",
  featuresTitle: "効率的なゲームローカライズソリューション",
  
  feature1Title: "高効率・迅速な完成",
  feature1Description: "より短い期間で正確かつ高品質な翻訳を実現し、20万文字のプロジェクトを1日で完了できます。ゲームプロジェクトのローカライゼーション効率を大幅に向上させます。従来の人力翻訳と比較して、人的ミスを大幅に削減し、大文字・小文字や句読点の違いを正確に識別します。翻訳品質は翻訳機関による認証を取得しています。",
  
  feature2Title: "多言語・マルチシナリオ対応", 
  feature2Description: "世界64言語の翻訳サービスを提供し、ゲームスクリプト、ストアページ、ゲームタイトル、用語集、公式サイトなど、多様なシーンのコンテンツ翻訳に対応。お客様のローカライゼーションニーズを全面的にサポートします。",
  
  // Feature 2 Additional
  glossary: "用語集",
  gameTermsReference: "ゲーム専門用語対照表",
  storePage: "ストアページ",
  storePageDesc: "ゲーム名、紹介文、セールスポイント、キャッチコピー",
  gameStoryTranslation: "ゲームシナリオ翻訳",
  gameStoryDesc: "メインストーリー、サブストーリー",
  completed: "完了",
  inProgress: "翻訳中",
  pending: "未対応",

  feature3Title: "多様なテキスト形式に対応",
  feature3Description: "多様なテキスト形式のインポート・エクスポートに対応しており、翻訳済みテキストをゲームプロジェクトへスムーズに組み込めます。どのゲームエンジンをお使いでも、効率的に連携可能です。",
  
  feature4Title: "ゲームに精通したローカライゼーションサービス",
  feature4Description: "ゲームローカライゼーション翻訳に特化し、ゲームテキスト、会話、UIなど多様なシーンのコンテンツニーズを深く理解しています。豊富なゲーム用語データベースを保有し、ネイティブな表現でゲーム体験を向上させ、プレイヤーに伝わりやすいゲームを実現します。",
  
  // Feature 4 Additional
  professionalGlossary: "専門用語集",
  more: "その他",
  
  // Features Section Additional
  translationTimeComparison: "翻訳時間の比較",
  basedOnProject: "20万文字のプロジェクトを基準",
  traditionalAgency: "従来の翻訳会社",
  aiPlatform: "Flidge AI 翻訳サービス",
  days: "日",
  day: "日",
  hours: "時間",
  hour: "時間",
  "10days": "10日",
  "1day": "1日",
  "240hours": "240時間", 
  "24hours": "24時間",

  // Case Studies Section
  casesSubtitle: "実績紹介",
  casesTitle: "インディーゲームを世界中のプレイヤーに見つけてもらう",
  casesDescription: "私たちは一つひとつのご協力の機会を大切にしています。世界中のより多くのプレイヤーにインディーゲームを届けていくこと、それが私たちの使命です",
  
  // Game Types
  platformActionGame: "プラットフォームアクションゲーム",
  musicRhythmGame: "音楽リズムゲーム",
  actionStealthGame: "アクションステルスゲーム",
  casualPuzzleGame: "カジュアルパズルゲーム",
  roguelikeCardGame: "ローグライクカード戦略ゲーム",
  simulationGame: "経営シミュレーションゲーム",
  
  // Game Descriptions
  haakDescription: "メトロイドヴァニア系ゲーム「HAAK」に14言語の翻訳サポートを提供し、月間売上が147%増加",
  museDashDescription: "音楽ゲーム「Muse Dash」に日本語、韓国語、英語の翻訳サポートを提供し、世界中の数億人のプレイヤーに高品質なローカライズコンテンツを提供しました",
  kristalaDescription: "アクションステルスゲーム「Kristala」の中国語ローカライズを担当し、ゲームタイトルとストアページの翻訳も手がけました",
  lazyMeowDescription: "カジュアルパズルゲーム「Lazy Meow City」に英語、日本語、韓国語のローカライゼーションサポートを提供し、アジア太平洋市場での市場開拓を支援",
  stoneSquadDescription: "「StoneSquad」に英語、日本語、韓国語、ポルトガル語、スペイン語など30言語のサポートを提供",
  catHotelDescription: "「CatHotel」に英語、日本語、簡体字中国語、繁体字中国語のストーリー、クエスト、アイテム、ストアページの翻訳サービスを提供し、各地域のプレイヤーに最適なゲーム体験を提供",
  
  // Results
  monthlyRevenueGrowth: "月間収益147%増加",
  playerReviews: "プレイヤー好評",
  translationCompleted: "翻訳完了",
  salesIncrease: "売上増加",
  exposureGrowth: "露出増加",
  playerReviews2: "プレイヤー好評",
  result: "結果",
  customerReviews: "お客様の声",
  realUserFeedback: "実際のユーザーフィードバック",
  
  // Pricing Section
  pricingSubtitle: "サービス料金",
  pricingTitle: "透明な料金プラン",
  pricingDescription: "さまざまな規模のプロジェクトに対応する柔軟な料金プランをご用意しています。すべてのお客様に無料トライアルをご利用いただけます。",
  
  freeTrialTitle: "無料お試し",
  standardPricing: "標準価格",
  standardPricingDescription: "無料枠を超えた場合の料金",
  standardPricingFeatures: {
    languages: "64言語の翻訳に対応",
    speed: "24時間以内に20万文字の翻訳に対応",
    formats: "多様なファイル形式に対応",
    glossary: "専門ゲーム用語集",
    quality: "品質保証・校正サービス"
  },
  customPrice: "カスタム",
  customPlan: "料金プラン",
  customPlanDescription: "大型案件向け特別価格",
  
  // Enterprise Features
  enterpriseCustom: "エンタープライズ",
  recommended: "おすすめ",
  perCharacter: "1文字あたり",
  perLanguage: "言語ごと",
  startUsing: "今すぐ始める",
  contactBusinessTeam: "営業チームに問い合わせる",
  
  enterpriseFeatures: {
    allStandard: "スタンダード版の全機能を含む",
    manager: "専任担当者によるサポート",
    priority: "優先対応・緊急対応",
    customGlossary: "カスタム用語集とスタイルガイド",
    discount: "ボリューム割引・長期利用特典",
    extraTrial: "無料トライアルの追加枠申請"
  },

  // Pricing Section Additional
  languagesCount: "言語",
  freeExperience: "無料トライアル", 
  freeTrialDescription: "各パートナー様には、1言語5000文字までの無料トライアルをご用意しており、翻訳品質を十分にお試しいただけます",
  
  // New Pricing Calculator Section
  priceCalculator: "料金シミュレーター",
  calculatorDescription: "プロジェクトの翻訳コストをすぐに見積もる",
  charactersCount: "使用可能文字数",
  targetLanguagesCount: "対象言語数",
  estimatedCost: "見積もりコスト",
  
  calculationNotes: "計算方法",
  calculationDetails: {
    freeQuota: "各パートナー様に5,000文字の無料枠をご利用いただけます（1言語のみ）",
    pricing: "無料枠超過分は$0.011/文字/言語でご請求いたします",
    bulkDiscount: "大規模プロジェクトには企業向けカスタム価格をご用意",
    finalPrice: "最終価格は担当者のお見積りに準じます"
  },

  // About Section
  aboutSubtitle: "私たちについて",
  aboutTitle: "プロのゲームローカライゼーションチーム",
  aboutDescription: "Flidgeは2019年に設立された、ゲームローカライゼーションに特化したテクノロジー企業です。AI技術と専門家による校正を組み合わせ、世界中のゲーム開発者に高品質かつ高効率な多言語ローカライゼーションサービスを提供し、優れたゲーム作品の世界展開を支援しています。",
  
  ourMission: "私たちのミッション",
  ourVision: "私たちのビジョン",
  missionText: "先進的なAI技術と専門的なローカライゼーションサービスを通じて言語の壁を打ち破り、あらゆる優れたゲームを世界市場での成功へと導き、世界中のプレイヤーに最高のゲーム体験をお届けします。",
  visionText: "技術革新と専門的なサービスにより、世界トップクラスのゲームローカライゼーションプラットフォームを目指し、ゲーム業界のグローバル展開を支援します。優れたゲーム文化を世界中へ届けることが私たちの使命です。",
  
  // FAQ Section
  faqSubtitle: "よくある質問",
  faqTitle: "よくある質問",
  faqDescription: "ご不明な点がございましたら、お気軽にお問い合わせください",
  stillHaveQuestions: "ご不明な点はありますか？",
  
  faqQuestion1: "無料でお試しできますか？",
  faqQuestion2: "ゲーム開発のどの段階でFlidgeのサービスの利用を始めるのがよいでしょうか？",
  faqQuestion3: "用語集がない場合はどうしたらいいですか？",
  faqQuestion4: "ゲームコンテンツは厳重に保護されますか？",
  
  // FAQ Items
  faq1Question: "無料でお試しできますか？",
  faq1Answer: "各パートナー様には、5,000文字まで1言語の翻訳を無料でお試しいただけます。5,000文字を超過した分については、1文字・1言語につき0.016米ドルの料金が発生いたします。さらなる無料枠をご希望の場合は、営業チームまでお問い合わせください。",
  
  faq2Question: "ゲーム開発のどの段階でFlidgeのサービスの利用を始めるのがよいでしょうか？",
  faq2Answer: "ゲームプロジェクトの開発中期から後期段階でFlidgeのサービスをご利用いただくことをお勧めします。ローカライゼーションコストを最大限に抑えられるだけでなく、ストアページの翻訳サポートや、プレイヤーに覚えてもらいやすい現地向けのゲームタイトルの選定もお手伝いします。グローバル市場の開拓をより効果的に進めることができます。Steamなどのゲームプラットフォームでまもなくリリースを控えている場合、Flidgeのサービスは特に最適です。短期間で大量かつ多言語のローカライゼーション作業を完了し、世界中のプレイヤーにあなたのゲームを届けることができます。",
  
  faq3Question: "用語集がない場合はどうしたらいいですか？",
  faq3Answer: `Flidge AIでは、用語集の整理サービスを提供しております。プロジェクトや翻訳コンテンツの効果的な管理をサポートし、用語の使用方法について確認・調整を行いながら、ゲーム内での正確な表現を実現します。
用語集整理サービスをご希望の際は、お気軽にご相談ください。`,
  
  faq4Question: "ゲームコンテンツは厳重に保護されますか？",
  faq4Answer: "業界標準の暗号化と、ゲームプロジェクト専用の分離ワークフローを採用しています。チームメンバー全員が厳格な秘密保持契約のもとで業務を行い、明確な財務責任を負っています。開発環境では完全な資産分離を実現しており、スクリーンショット撮影、外部ドライブ、個人デバイスの使用は一切禁止されています。ゲーム画面、ストーリー要素、リリース日の漏洩が市場でのインパクトを台無しにしかねないことを十分に理解しております。お客様の知的財産には、私たち自身の未発表作品と同等の保護をお約束いたします。",

  // CTA Section
  ctaTitle1: "世界を魅了しよう",
  ctaTitle2: "あなたのゲームで",
  
  // Contact Section
  contactSubtitle: "お問い合わせ",
  contactTitle: "プロフェッショナルな翻訳サービスと無料お試し枠をご提供",
  contactDescription: "以下のフォームにご記入いただければ、専門チームが24時間以内に詳細なサービスプランをお届けいたします",
  
  name: "お名前",
  email: "メールアドレス",
  company: "会社名/スタジオ名",
  targetLanguages: "翻訳言語",
  projectDetails: "プロジェクト詳細",
  getQuote: "見積もりを取得",
  onlineConsult: "オンライン相談",
  emailContact: "メールで問い合わせ",
  
  // Footer
  footerDescription: "インディーゲーム向けに、効率的でコストパフォーマンスに優れたローカライゼーションサービスを提供しています。AI翻訳、分析、カスタマイズ言語サービスを通じて、ゲームプロジェクトのグローバル展開をサポートします。",
  services: "サービス",
  companySection: "会社",
  resources: "リソース",
  featuresLink: "主な強み",
  pricingConsult: "サービス料金",
  aboutUs: "私たちについて",
  helpCenter: "ヘルプセンター",
  techBlog: "技術ブログ",
  termsOfService: "利用規約",
  privacyPolicy: "プライバシーポリシー",
  cookiePolicy: "Cookieポリシー",
  poweredBy: "Powered by Readdy",
  copyright: "© 2025 Flidge AI 翻訳サービス",
  
  // Form labels
  required: "*",
  characterCount: "文字",
  
  // Form placeholders
  namePlaceholder: "お名前を入力してください",
  emailPlaceholder: "メールアドレスを入力してください",
  companyPlaceholder: "会社またはスタジオ名を入力してください",
  languagesPlaceholder: "例：英語、日本語、韓国語など",
  messagePlaceholder: "ゲームタイプ、翻訳コンテンツ、特別要件などを含むプロジェクト要件を詳しく説明してください...",
  
  // Alt texts
  gameIcon: "ゲームアイコン",
  flidgeLogo: "Flidgeロゴ",
  abstractShape: "抽象形状",
  
  // Testimonials
  testimonialSarahRole: "インディーゲーム開発者",
  testimonialSarahContent: "Flidgeを利用してから、海外市場での反響が非常に良好です。翻訳品質は期待を大きく上回り、プレイヤーからはストーリーが的確に伝わっていて、機械翻訳っぽさが全くないというフィードバックをいただいています。",
  
  testimonialThijsRole: "ゲームスタジオディレクター",
  testimonialThijsContent: "初期のシナリオ翻訳から後期の文章のブラッシュアップまで、Flidgeチームにはプロフェッショナルな対応をしていただきました。ゲーム文化への深い理解のおかげで、ローカライゼーション作業をスムーズに進めることができました。",
  
  testimonialEmmaRole: "ゲームローカライゼーションマネージャー",
  testimonialEmmaContent: "Flidgeの翻訳サービスのおかげで、大幅な時間とコストの削減を実現できました。彼らのAI技術は迅速なだけでなく、ゲームの専門用語や文化的なニュアンスを正確に理解してくれます。",
  
  testimonialDavidRole: "ゲームプロデューサー",
  testimonialDavidContent: "日本と韓国市場での大成功は、Flidgeが提供してくれた高品質なローカライゼーションサービスのおかげです。東アジア文化への深い理解により、翻訳がよりネイティブに近い自然なものになりました。",
  
  testimonialAlexRole: "インディー開発者",
  testimonialAlexContent: "小規模チームとして、最も心配だったのがローカライゼーションコストでした。Flidgeは価格が手頃なだけでなく、効率も非常に高く、複数の海外市場に同時進出することができました。",
  
  testimonialYukiRole: "ゲームプランナー",
  testimonialYukiContent: "日本のゲーム文化に対するFlidgeの理解には本当に感銘を受けました。単なる文字の翻訳にとどまらず、ゲームの精神性まで伝えてくれたおかげで、海外プレイヤーにも原作の魅力そのままの体験を届けられています。",
  
  abstractShape2: "抽象形状2",

  // New entries from modification
  partners: "パートナー",
  trustedPartners: "信頼できるパートナー",
  partnersDescription: "世界トップクラスのゲームチームや企業と長期的な協力関係を構築",

  gameProjectsServed: "導入企業数",
  supportedLanguages: "対応言語数",
  clientSatisfaction: "顧客満足度",
  responseTime: "応答時間",

  // Additional Metrics
  translatedCharactersCount: "500万+",
  avgTranslationSpeedValue: "3.2秒",
  translatedCharacters: "翻訳文字数",
  avgTranslationSpeed: "翻訳速度(1000文字あたり)",
  clientSatisfactionRate: "顧客満足率",
  servicedCompanies: "導入企業数",
  successMetrics: "成功指標",
  serviceImpact: "サービスの影響力",

  // Statistics
  stat1Number: "80+",
  stat1Label: "導入企業数",
  stat2Number: "64",
  stat2Label: "対応言語数",
  stat3Number: "97%",
  stat3Label: "顧客満意度",
  stat4Number: "24時間",
  stat4Label: "応答時間",

  // Added entries from modified content
  professionalTerminologyDatabase: "専門用語データベース",
  cheese: "Cheese",
  feeding: "Feeding",
  rush: "Rush",
  balance: "Balance",
  fightingGamesJapanese: "格闘ゲーム - 日本語",
  mobaGamesKorean: "MOBAゲーム - 韓国語",
  starcraftRussian: "スタークラフト - ロシア語",
  actionGamesChinese: "アクションゲーム - 中国語"
};

export default common;
